import createCookieFactory from "../../cookieFactory";

export default (featureFlag) => {
  const cookie = createCookieFactory(`feature_flags.${featureFlag}`);

  return {
    get enabled() {
      return cookie.get() === "true";
    },
  };
};
